<template>
    <div>
        <ui-modal :title="modalTitle" ref="bookingModal" :size="modalSize" :class="modalClasses" :contain-focus="false" @hide="hidden" dismiss-on="close-button esc">
            
            <!-- New Booking !-->
            <div v-if="isNewBooking">

                <div class="row" style="margin-top: 1rem;">
                    <div class="col-6">
                        <ui-datepicker label="Date" v-model="dateProxy" placeholder="Booking Date" append-dropdown-to-body :start-of-week="1"></ui-datepicker>
                    </div>
                    <div class="col-6">
                        <ui-select v-if="timeProxy" label="Drop-off Time" :options="timeOptions" v-model="timeProxy" placeholder="Time"></ui-select>
                    </div>
                    <div class="col-6">
                        <ui-select v-if="toProxy" label="Duration" :options="durationOptions" v-model="toProxy" placeholder="Booking Duration"></ui-select>
                    </div>
                </div>
                
                <hr>

                <div class="row">
                    <div class="col-12">
                        <vehicle-picker
                            :status="validVehicleStatuses"
                            label="Vehicle"
                            v-model="instanceProxy"
                            :additional-relations-to-load="['owner', 'warranty']"
                        />
                        <div v-if="instanceIsWarrantyEligible && !isLoadingProducts">
                            <div v-if="hasLegacyWarranty || hasWarrantyProduct">
                                <div v-if="hasRefundedWarrantyProduct" style="color: orange; background: #ffa5001f; padding: .5rem 1rem; border-radius: 3px;">
                                    <span class="material-icons" style="vertical-align: middle;">warning</span>
                                    <span>The vehicles warranty was <strong>refunded</strong> on the {{ formatDate(warrantyProduct.refunded_at, 'D/M/YYYY') }}.</span>
                                </div>
                                <div v-else-if="hasValidLegacyWarranty || hasValidWarrantyProduct" style="color: green; background: #0080001c; padding: .5rem 1rem; border-radius: 3px;">
                                    <span class="material-icons" style="vertical-align: middle;">check</span>
                                    <span v-if="hasLegacyWarranty">The vehicles warranty is <strong>valid</strong> until the {{ formatDate(instanceProxy.warranty.valid_to, 'D/M/YYYY') }}.</span>
                                    <span v-else>The vehicles warranty is <strong>valid</strong> until the {{ formatDate(warrantyProduct.expires_at, 'D/M/YYYY') }}.</span>
                                </div>
                                <div v-else style="color: orange; background: #ffa5001f; padding: .5rem 1rem; border-radius: 3px;">
                                    <span class="material-icons" style="vertical-align: middle;">warning</span>
                                    <span v-if="hasLegacyWarranty">The vehicles warranty <strong>expired</strong> on the {{ formatDate(instanceProxy.warranty.valid_to, 'D/M/YYYY') }}.</span>
                                    <span v-else>The vehicles warranty <strong>expired</strong> on the {{ formatDate(warrantyProduct.expires_at, 'D/M/YYYY') }}.</span>
                                </div>
                            </div>
                            <div v-else style="color: red; background: #ff00001c; padding: .5rem 1rem; border-radius: 3px;">
                                <span class="material-icons" style="vertical-align: middle;">warning</span>
                                This vehicle is has no warranty.
                            </div>
                        </div>
                    </div>
                </div>

                <hr>
                
                <div class="row">
                    <div class="col-12">
                        <keen-contact-picker label="Customer" v-model="customerProxy" :new-contact-defaults="contactDefaults"></keen-contact-picker>
                    </div>
                    <div v-if="canBookCourtesyCar" class="col-12">
                        <ui-switch v-model="booking.requires_courtesy_car">Courtesy car required?</ui-switch>
                    </div>
                    <div v-if="canBookCourtesyCar && booking.requires_courtesy_car" class="col-12">
                        <reservation-availability
                            v-if="calendarEntry.from && calendarEntry.to"
                            :from="calendarEntry.from"
                            :to="calendarEntry.to"
                            :current-booking-id="booking.reservation ? booking.reservation.id : false"
                        />
                    </div>
                </div>

                <div v-if="!isEditMode">
                    <hr>
                     <!--<div class="row">
                        <div class="col-12">
                            <label class="ui-select__label-text large-label" style="margin-bottom: 1rem;">Jobs</label>
                        </div>
                    </div>

                   <div class="row" v-for="(task, i) in tasks">
                        <div class="col" style="font-size: 1.5rem; max-width: 30px;">{{ i + 1 }}.</div>
                        <div class="col">
                            <ui-textbox v-model="tasks[i].title" placeholder="Enter a brief job summary" @input="taskChanged(tasks[i])"></ui-textbox>
                        </div>
                    </div>!-->

                    <div class="row" style="margin-bottom: .5rem">
                        <div class="col"><h5>Jobs</h5></div>
                        <div class="col text-right"><a href="#" class="pill pill-sm pill-green" title="Add Bill" @click.prevent="$refs.newTasksCard.addTask()">
                            <i class="material-icons">add</i>
                        </a></div>
                    </div>
                    
                    <task-card 
                        ref="newTasksCard" 
                        :value="tasks" 
                        @updated="taskUpdated"
                        @destroyed="taskDestroyed"
                        :task-template-context="TaskTemplateContexts.BOOKINGS"
                        :save-tasks="false"
                        :show-warranty-item-options="true"
                        :allow-vehicle-editing="false"
                        :show-new-job-instance="false"
                        :default-task-attributes="{ type: 'job', instance_id: booking.instance_id }"
                    ></task-card>
                
                    <hr>
                    
                    <div class="row">
                        <div class="col-12">
                            <label class="ui-select__label-text large-label" style="margin-bottom: 1rem;">Comments</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <ui-textbox v-model="comment.content" class="comments-text-box" multi-line :rows="2" placeholder="Enter any other information related to the booking..."></ui-textbox>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Loader !-->
            <div v-else-if="isLoading">
                <cog-loader></cog-loader>
            </div>

            <!-- Existing Booking !-->
            <div class="container-fluid" v-else>
                <div class="row">
                    <div class="col" style="padding-top: 1.5rem;">
                        <div v-if="isCompleted" class="row align-items-center">
                            <div class="col-12">
                                <ui-alert type="success" icon="info" :dismissible="false">
                                    Booking completed <span v-if="this.booking.invoice_id">&amp; invoiced</span>
                                </ui-alert>
                            </div>
                        </div>
                        <div ref="printable">
                        <div class="row align-items-center">
                            <div class="col-8">
                                <!--<h1 @click.prevent="$root.navigateTo('contacts/%s', [booking.contact_id])" style="display: block; font-size: 1.8rem; font-weight: 400; margin-bottom: 0; cursor: pointer;">{{ booking.contact.primary_display_as }}</h1>!-->
                                <contact-name-and-details 
                                    style="display: block; font-size: 1.8rem; font-weight: 400; margin-bottom: 0; cursor: pointer;"
                                    link-colour="#000"
                                    :contact="booking.contact"
                                />
                            </div>
                            <div class="col text-right">
                                <div style="color: #666;">
                                    <span class="material-icons" style="vertical-align: middle">date_range</span> 
                                    <span>{{ calendarEntry.from | formatDate }}</span>
                                    <span v-if="timeProxy.value.hours > 0"> @ {{ calendarEntry.from | formatTime }}</span>
                                    <span v-if="toProxy.days > 1"> - {{ calendarEntry.to | formatDate }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="row align-items-center" style="margin-top: .5rem;">
                            <div class="col-7">
                                <a @click.prevent="$root.navigateTo('vehicles/%s/overview', [booking.instance_id])" style="cursor: pointer;">
                                    <span class="registration small" style="margin-top: 0;">
                                        {{ booking.instance.vehicle.registration.formatted_vrm }}
                                    </span>
                                    <span style="display: inline-block; margin-left: .25rem; max-width: 240px; vertical-align: middle;" class="truncate">{{ booking.instance.vehicle.file_as }}</span>
                                </a>

                                <booking-tag-cloud :booking="booking" style="font-size: 1rem; margin-top: .6rem;"></booking-tag-cloud>
                            </div>
                            <div class="col text-right">
                                <div v-if="booking.assignee">
                                    <span style="color: #ccc; font-size: .8rem">Assigned to:</span>
                                    <avatar :user="booking.assignee" />
                                </div>
                            </div>
                        </div> 
                            
                        <hr>

                        <div class="row">
                            <div class="col">

                                <!-- Tasks / Jobs !-->
                                <div class="row" style="magin-top: 1rem; margin-bottom: .5rem">
                                    <div class="col"><h5>Jobs</h5></div>
                                    <div class="col text-right">
                                        <a href="#" class="pill pill-sm pill-green" title="Add Bill" @click.prevent="$refs.tasksCard.addTask()">
                                        <i class="material-icons">add</i>
                                        </a>
                                        <a href="#" class="pill pill-sm pill-dark" title="Add Bill" @click.prevent="printJobCard">
                                        <i class="material-icons">print</i>
                                        </a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <task-card 
                                            ref="tasksCard" 
                                            :value="booking.tasks" 
                                            @updated="taskUpdated"
                                            @destroyed="taskUpdated"
                                            :show-warranty-item-options="true"
                                            :allow-vehicle-editing="false"
                                            :default-task-attributes="{ type: 'job', booking_id: booking.id, instance_id: booking.instance_id }"
                                        ></task-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                        <div class="row">
                            <div class="col">
                                <!-- VHC !-->
                                <div v-if="booking.inspections && booking.inspections.length > 0" style="margin-top: 1rem;" class="row">
                                    <div class="col">
                                        <div style="margin-top: 1rem;">
                                            <h5>Health Checks</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <inspections-card
                                            :inspections="booking.inspections"
                                            @updated="reload"
                                            @tasks-updated="reload"
                                        ></inspections-card>
                                    </div>
                                </div>

                                <!-- Advisories !-->
                                <div style="margin-top: 1rem;" class="row">
                                    <div class="col">
                                        <div style="margin-top: 1rem;">
                                            <h5>Advisories</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div style="background-color: rgb(250, 250, 250); padding: 2rem 1rem;">
                                            <div 
                                                class="card" 
                                                :style="'padding: 1rem;' + (!isCompleted ? 'margin-bottom: 1rem;' : '')"
                                            >
                                                <div v-if="!hasAdvisories">
                                                    There are no advisories
                                                </div>
                                                <template v-else>
                                                    <div v-for="(advisory, k) in booking.advisories" :key="k">
                                                        <div class="row align-items-center">
                                                            <div class="col">
                                                                {{ advisory }}
                                                            </div>
                                                            <div class="col-2 text-center">
                                                                <ui-icon-button
                                                                    v-if="!isCompleted"
                                                                    icon="delete"
                                                                    type="secondary"
                                                                    :disabled="isAddingAdvisory"
                                                                    @click="removeAdvisory(advisory)"
                                                                />
                                                            </div>
                                                            <div
                                                                v-if="k !== (booking.advisories.length - 1)"
                                                                class="col-12"
                                                            >
                                                                <hr>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                            <div v-if="!isCompleted" class="card" style="padding: 1rem;">
                                                <div class="row">
                                                    <div class="col">
                                                        <ui-textbox
                                                            v-model="newAdvisory"
                                                            placeholder="Example: N/S/F tyre wall damage"
                                                            style="margin-bottom: 0;"
                                                            :disabled="isLoading"
                                                        />
                                                    </div>
                                                    <div class="col" style="max-width: 110px;">
                                                        <ui-button 
                                                            color="primary" 
                                                            @click="addAdvisory"
                                                            :disabled="isLoading"
                                                            :loading="isAddingAdvisory"
                                                        >
                                                            Add
                                                        </ui-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Mileage & Service Log !-->
                                <div v-if="isWorkShopGroup" class="row" style="margin-top:1rem">
                                    <div class="col">
                                        <div style="margin-bottom: 1rem;">
                                            <h5>Mileage Log &amp; Service Stamp</h5>
                                        </div>
                                        <div style="background-color: rgb(250, 250, 250); padding: 2rem 1rem;">
                                            <div class="card text-center" style="padding: 1rem;">
                                                <div v-if="!booking.mileage_log_entry">
                                                    <span class="material-icons" style="color: gold; font-size: 2rem;">warning</span>
                                                    <h5>Not entered</h5>
                                                </div>
                                                <div v-else>
                                                    <span class="material-icons" style="color: green; font-size: 2rem;">check_circle</span>
                                                    <h5>{{ booking.mileage_log_entry.miles | formatNumber }} miles</h5>
                                                    <span v-if="booking.mileage_log_entry.service_record">Serviced ({{ booking.mileage_log_entry.service_record.type }})</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                                <!-- Comments !-->
                                <div style="margin-top: 1rem;" class="row">
                                    <div class="col">
                                        <div style="margin-bottom: 1rem;">
                                            <h5>Comments</h5>
                                        </div>
                                        <div style="background-color: rgb(250, 250, 250); padding: 1rem;">
                                        <comments-pane 
                                            :owner-type="modelName"
                                            :owner-id="booking.id"
                                            @saved="taskUpdated"
                                            style="background: #fff; padding: .5rem 1rem 1rem"
                                        ></comments-pane>  
                                    </div>
                                    </div>
                                </div>

                                <!-- Invoice !-->
                                <div class="row" v-if="booking.invoice" style="margin-bottom: 1rem;">
                                    <div class="col">
                                        <div style="margin-bottom: 1rem; margin-top: 1rem;">
                                            <h5>Invoice</h5>
                                        </div>
                                        <div style="background-color: rgb(250, 250, 250); padding: 1rem;">
                                            <invoice :invoice="booking.invoice" class="card"></invoice>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3" style="background: rgb(250, 250, 250); padding-top: 1.5rem;">
                        <div v-if="!isCompleted">
                            <h5 style="margin-bottom: 1rem; margin-top: .5rem;">Vehicle</h5>
                            <ui-button
                                icon="timelapse"
                                style="width: 100%; margin-bottom: 0.5rem; justify-content: left;"
                                @click.prevent="$refs.mileageLogModal.open(booking.id)"
                            >Log Mileage</ui-button>
                            <ui-button
                                style="width: 100%; margin-bottom: 0.5rem; justify-content: left;"
                                icon="beenhere"
                                @click.prevent="$refs.presenceModal.open(booking)"
                            >Set Presence</ui-button>
                        </div>

                        <h5 style="margin-bottom: 1rem; margin-top: 1rem;">Booking</h5>

                        <!-- Assign a user !-->
                        <assign-selector 
                            v-show="!isCompleted"
                            ref="assignSelector" 
                            :user="this.booking.assignee" 
                            :is-loading="isAssigning"
                            :team="booking.team_id"
                            @save="bookingAssigned" 
                        ></assign-selector>

                        <ui-button
                            style="width: 100%; margin-bottom: 0.5rem; justify-content: left;"
                            icon="description"
                            @click.prevent="quoteBooking"
                            v-if="showQuoteCtas && (!isCompleted || isCompleted && booking.quote)"
                        >Quote</ui-button>
                        <ui-button
                            style="width: 100%; margin-bottom: 0.5rem; justify-content: left;"
                            icon="attach_money"
                            :loading="isLoadingInvoice"
                            @click.prevent="invoiceBooking"
                        >Invoice</ui-button>
                        <!-- Complete !-->
                        <ui-button 
                            :loading="isCompleting"
                            v-show="!isCompleted"
                            @click="complete" 
                            icon="check" 
                            style="width: 100%; margin-bottom: .5rem; justify-content: left;" 
                        >Complete</ui-button><!-- Complete !-->
                        <ui-button 
                            :loading="isReopening"
                            v-show="isCompleted"
                            @click="reopen" 
                            icon="undo" 
                            style="width: 100%; margin-bottom: .5rem; justify-content: left;" 
                        >Reopen</ui-button>
                        <ui-button
                            v-show="!isCompleted"
                            style="width: 100%; margin-bottom: 0.5rem; justify-content: left;"
                            icon="edit"
                            @click.preven="isEditMode = true"
                        >Edit</ui-button>
                        <ui-button
                            style="width: 100%; margin-bottom: 0.5rem; justify-content: left;"
                            icon="delete"
                            @click.prevent="destroy"
                        >Delete</ui-button>
                    </div>
                </div>
            </div>

            <div slot="footer" style="width: 100%; text-align: right;" v-if="(!booking.id || booking.id && true === isEditMode) && !isLoading">
                <ui-progress-circular v-show="isLoading" style="float:left;"></ui-progress-circular>
                <button :disabled="isLoading" class="btn btn-primary" @click="save">Save</button>
            </div>

            <vehicle-presence-modal ref="presenceModal" @saved="presenceUpdated"></vehicle-presence-modal>

            <vehicle-mileage-log-entry-modal 
                ref="mileageLogModal" 
                :instance="booking.instance"
                @saved="mileageLogUpdated"
            ></vehicle-mileage-log-entry-modal>

            <invoice-modal 
                ref="invoiceModal" 
                @saved="invoiceSaved" 
                @destroyed="invoiceDestoyed" 
                :print-on-save="true"
            ></invoice-modal>
        </ui-modal>

        <ui-modal 
            title="Create Invoice" 
            ref="invoicingMethod"
        >
            <p>Do you want to create an invoice based on actual costs or the quoted amount?</p>
            <ui-radio-group 
                v-model="selectedTemplate"
                :options="invoicingOptions"
                name="'invoicingMethod"
            />
            <ui-button 
                style="margin-top: 1rem;"
                color="primary"
                @click="invoicingMethodSelected(invoiceTemplates[selectedTemplate])"
                :disabled="!selectedTemplate || '' === selectedTemplate"
            >
                Next
            </ui-button>
        </ui-modal>
        <full-screen-document-viewer
            :base-uri="documentUrl"
            ref="documents"
        ></full-screen-document-viewer>
    </div>
</template>

<style lang="scss">
    .booking-modal {
        .large-label,
        .comments-text-box > .ui-textbox__content > .ui-textbox__label > .ui-textbox__label-text,
        .keen-vehicle-selector > .ui-select > .ui-select__content > .ui-select__label > .ui-select__label-text,
        .contact-picker > .ui-select > .ui-select__content > .ui-select__label > .ui-select__label-text {
            font-size: 1.2rem;
            margin-top: .5rem;
            font-weight: normal;
        }

        &.view-booking { 
            & > div > div > div > div.ui-modal__body { 
                padding-top: 0 !important;
                padding-bottom: 0 !important;
                padding-right: 1rem !important;

                & > .container-fluid {
                    padding: 0px 0px 1rem;
                }
            }
        }

        &.is-loading, &.view-booking {
           & > div > div > div > div.ui-modal__footer { display: none; }
        }

        .contact-details {
            padding: 0;
            margin-bottom: 0;
            li { 
                display: inline-block; 
                list-style: none; 
                padding: 0 .5rem;
                border-right: 1px solid #ccc; 
                &:first-of-type { padding-left: 0; }
                &:last-of-type { padding-right: 0; border-right: none; }
            }
        }

        .invoice-layout {
            padding: 0 1rem;
            table.table { margin: 1rem 0; }
        }
    }
</style>


<script>
    import AssignSelector from '../forms/controls/AssignSelector'
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'
    import Moment from 'moment'
    import Filters from '../../filters'
    import { VehicleLifeCycleStatuses, VehicleInstanceResource } from '../../classes/Api/Vehicle'
    import { InvoiceResource, InvoiceHelper } from '../../classes/Api/Invoice'
    import { BookingSchema, BookingResource, BookingPresenceStatuses } from '../../classes/Api/Booking'
    import {TaskSchema, TaskResource, TaskTypes, TaskTemplateContexts} from '../../classes/Api/Task'
    import { CommentSchema, CommentResource } from '../../classes/Api/Comment'
    import { CalendarEntrySchema, CalendarResource } from '../../classes/Api/Calendar'
    import { ContactTypes } from '../../classes/Api/Contact'
    import { TeamTypes } from '../../classes/Api/User'
    import TaskCard from '../elements/TaskCard'
    import CommentsPane from '../comments/CommentsPane'
    import VehiclePresenceModal from './VehiclePresenceModal'
    import BookingTagCloud from './BookingTagCloud'
    import InvoiceModal from '../forms/InvoiceModal'
    import Invoice from '../elements/Invoice'
    import VehicleMileageLogEntryModal from '../forms/vehicles/VehicleMileageLogEntryModal'
    import SharedHelpersMixin from "../BookingAndReservationUiHelpers";
    import ReservationAvailability from "../reservations/ReservationAvailability";
    import BookingUiHelpers from "./BookingUiHelpers";
    import InspectionsCard from "../vehicles/show/InspectionsCard.vue";
    import {printElement, printElementViaCanvas} from "../../utils";
    import FullScreenDocumentViewer from "../FullScreenDocumentViewer.vue";
    import DealerKit from "../../api";
    import {ProductType} from "../../../../api-clients/ts";
    import formatDate from "../../filters/date/format";
    
    const bookingRelations = [
        'instance',
        'instance.warranty',
        'contact',
        'calendarEntry',
        'comments',
        'inspections',
        'tasks',
        'tasks.children',
        'tasks.template',
        'tasks.assignee',
        'invoice',
        'mileageLogEntry',
        'mileageLogEntry.serviceRecord',
        'team',
        'team.calendar',
        'quote',
        'assignee',
        'reservation',
    ]

    export default {
        mixins: [SharedHelpersMixin, BookingUiHelpers],
        components: {
            FullScreenDocumentViewer,
            InspectionsCard,
            VueTimepicker, 
            TaskCard, 
            CommentsPane, 
            VehiclePresenceModal, 
            BookingTagCloud,
            InvoiceModal,
            Invoice,
            VehicleMileageLogEntryModal,
            AssignSelector,
            ReservationAvailability,
        },
        props: {
            team: {},
            showQuoteCtas: {
                type: Boolean,
                default: true
            }
        },
        filters: {
            ...Filters,
            formatDate(value) {
                if ((new Moment(value)).format('MM YY') === (new Moment()).format('MM YY')) {
                    return (new Moment(value)).format('ddd D')
                }

                return (new Moment(value)).format('DD/MM/YY')
            },
            formatTime(value) {
                return (new Moment(value)).format('H:mma')
            }
        },
        data() {
            return {
                newAdvisory: '',
                booking: new BookingSchema(),
                calendarEntry: new CalendarEntrySchema(),
                tasks: [ /*new TaskSchema()*/ ],
                comment: new CommentSchema(),
                bookingOptions: [],
                isCompleting: false,
                isReopening: false,
                isLoading: false,
                isAddingAdvisory: false,
                isLoadingInvoice: false,
                isAssigning: false,
                isEditMode: false,
                contactDefaults: {
                    type: ContactTypes.CUSTOMER
                },
                loadedTeam: null,
                invoiceTemplates: null,
                selectedTemplate: '',
                modelName: 'booking',
                TaskTemplateContexts,
                products: [],
                isLoadingProducts: false,
            }
        },
        mounted() {
            this.$parent.$on('booking.updated', (booking) => {
                if (this.$refs.bookingModal.isOpen) {
                    this.load(this.booking.id)
                }
            })
        },
        saved() {
            CalendarResource.find(this.passedOrLoadedTeam.calendar.id, { with: ['entryTypes'] }).then(response => {
                this.bookingOptions = response.data.entry_types.map(item => {
                    return {
                        label: item.name,
                        value: item.id,
                        handle: item.handle,
                    }
                })
            })
        },
        computed: {
            documentUrl() {
                return `${window.marque.ui.baseEndpoint}/jobs/documents/booking-job-sheet?booking_id=${this.booking.id}`
            },
            instanceIsWarrantyEligible() {
                return this.instanceProxy.id && this.instanceProxy.life_cycle_status === VehicleLifeCycleStatuses.SOLD
            },
            hasLegacyWarranty() {
                return !!(this.instanceIsWarrantyEligible && this.instanceProxy.warranty);
            },
            hasValidLegacyWarranty() {
                return this.hasLegacyWarranty && Moment(this.instanceProxy.warranty.valid_to).isAfter(Moment());
            },
            warrantyProduct() {
                return this.products.find(product => product.type === ProductType.Warranty)
            },
            hasWarrantyProduct() {
                return !!(this.instanceIsWarrantyEligible && this.warrantyProduct);
            },
            hasValidWarrantyProduct() {
                return this.hasWarrantyProduct && Moment(this.warrantyProduct.expires_at).isAfter(Moment()) && !this.warrantyProduct.refunded_at
            },
            hasRefundedWarrantyProduct() {
                return this.hasWarrantyProduct && !!this.warrantyProduct.refunded_at
            },
            canBookCourtesyCar() {
                return this.toProxy && this.toProxy.days > 0
            },
            invoicingOptions() {
                let options = []

                for (let i in this.invoiceTemplates) {
                    if (this.invoiceTemplates[i]) {
                        let label = ('quoteBasis' === i ? 'Quoted Amount' : 'Actual Costs');
                        let helper = (new InvoiceHelper(this.invoiceTemplates[i]))
                        label += ' (£' + helper.total() + ')'

                        options.push({
                            label,
                            value: i
                        })
                    }
                }

                return options
            },
            passedOrLoadedTeam() {
                if (this.team) {
                    return this.team
                }

                return this.loadedTeam
            },
            isWorkShopGroup() {
                return this.passedOrLoadedTeam.type === TeamTypes.WORKSHOP
            },
            isCompleted() {
                return this.booking.completed_at !== null
            },
            isNewBooking() {
                return (!this.booking.id || this.booking.id && true === this.isEditMode) && !this.isLoading;
            },
            hasAdvisories() {
                return this.booking.advisories && this.booking.advisories.length > 0
            },
            modalClasses() {
                let str = 'booking-modal'

                if (!this.isNewBooking && !this.isLoading) {
                    str += ' view-booking'
                }

                if (this.isLoading) {
                    str += ' is-loading'
                }

                return str
            },
            validVehicleStatuses() {
                return [
                    VehicleLifeCycleStatuses.NON_STOCK,
                    VehicleLifeCycleStatuses.SOLD,
                ]
            },
            modalTitle() {
                if (this.isLoading) {
                    return '';
                }

                let title = !this.booking.id ? 'New Booking' : 'Booking'

                if (this.loadedTeam) {
                    title = this.loadedTeam.name + ' - ' + title
                }

                return title
            },
            modalSize() {
                return !this.booking.id || this.isLoading ? 'normal' : 'xlarge'
            },
            hasIncompleteTasks() {
                return this.tasks.filter(task => {
                    return !task.completed_at && !task.pending_complete_at
                }).length > 0
            },
            isBookingForSoldCar() {
                return VehicleLifeCycleStatuses.SOLD === this.booking.instance.life_cycle_status
            },
        },
        watch: {
            instanceProxy(n, o) {
                this.isLoadingProducts = true

                if (n && n.id) {
                    DealerKit.stockList.getStockListingActiveProducts(n.id).then(response => {
                        if (response.status !== 204) {
                            this.products = response.data.data
                        }
                    }).catch(e => {
                        if (!e.response || e.response.status !== 404) {
                            throw e
                        }
                    }).finally(() => {
                        this.isLoadingProducts = false
                    })
                } else {
                    this.isLoadingProducts = false
                }
            }
        },
        methods: {
            formatDate,
            printJobCard() {
                this.$refs.documents.open()
            },
            bookingAssigned(user) {
                this.isAssigning = true

                BookingResource.assign(this.booking.id, user.id, { with: bookingRelations }).then(r => {
                    this.booking = r.data;
                    this.isAssigning = false
                    this.$refs.assignSelector.close();
                    this.$emit('updated')
                }, e => { handleApiError(e); this.isAssigning = false })
            },
            addAdvisory() {
                this.isAddingAdvisory = true

                if (!this.booking.advisories) {
                    this.booking.advisories = []
                }

                this.booking.advisories.push(this.newAdvisory)

                this.newAdvisory = null

                this.saveAdvisories()
            },
            removeAdvisory(advisory) {
                if (confirm('Are you sure you want to remove \'' + advisory + '\' advisory?')) {
                    this.isAddingAdvisory = true

                    this.booking.advisories = this.booking.advisories.filter(item => advisory !== item)

                    this.newAdvisory = null

                    this.saveAdvisories()
                }
            },
            saveAdvisories() {                
                BookingResource.storeOrUpdate(this.booking.id, this.booking, { with: bookingRelations }).then(response => {
                    this.isAddingAdvisory = false
                }, e => { handleApiError(e); this.isAddingAdvisory = false; });
            },
            reopen() {
                let data = { 
                    completed_at: null
                }

                let params = { with: bookingRelations }
                this.isReopening = true;

                BookingResource.update(this.booking.id, data, params).then(response => {
                    this.setBookingData(response)
                    this.$emit('updated')
                    this.isReopening = false
                }, e => { handleApiError(e); this.isReopening = false });
            },
            complete() {
                // Prevent completing booking with open tasks.
                if (this.hasIncompleteTasks) {
                    alert('The booking has incomplete tasks.')
                    return
                }

                // Check the bookings reservation is booked back in.
                if (this.booking.reservation && !this.booking.reservation.booked_in_at) {
                    alert('The bookings courtesy car has not been booked in, please book this in before completing the booking.')
                    return
                }

                // If it's a Sold car - Prevent completing without mileage stamp.
                if (this.isBookingForSoldCar && this.isWorkShopGroup && !this.booking.mileage_log_entry) {
                    alert('Please log the vehicles mileage before completing this booking')
                    return
                } else if(
                    !this.booking.mileage_log_entry && 
                    this.isWorkShopGroup &&
                    !confirm('Are you sure you want to complete this booking without logging the vehicles mileage?')
                ) {
                    return;
                }

                // Warn if it's not invoiced.
                let msg = 'Are you sure that you want to complete the booking?'

                if (!this.booking.invoice_id) {
                    msg = 'The booking has not been invoiced, Are you sure you '
                    msg += 'want to continue?';
                }

                if (!confirm(msg)) {
                    return
                }

                let data = { 
                    completed_at: new Moment(),
                    vehicle_presence_status: BookingPresenceStatuses.CUSTOMER
                }

                let params = { with: bookingRelations }
                this.isCompleting = true;

                BookingResource.update(this.booking.id, data, params).then(response => {
                    this.setBookingData(response)
                    this.$emit('updated')
                    this.isCompleting = false
                }, e => { handleApiError(e); this.isCompleting = false });
            },
            mileageLogUpdated(logEntry) {
                this.booking.mileage_log_entry = logEntry
            },
            setBookingData(response) {
                this.booking = response.data;
                this.calendarEntry = response.data.calendar_entry;
                this.calendarEntry.from = new Moment(this.calendarEntry.from)
                this.tasks = response.data.tasks
            },
            invoiceSaved(invoice) {
                if (this.booking.invoice_id !== invoice.id) {
                    let data = { invoice_id: invoice.id }
                    let params = { with: bookingRelations }

                    BookingResource.update(this.booking.id, data, params).then(response => {
                        this.setBookingData(response)
                        this.$emit('updated')

                        this.$refs.invoiceModal.$refs.documents.open();
                    }, e => { handleApiError(e); });
                } else {
                    this.$refs.invoiceModal.close();
                }
            },
            invoiceDestoyed() {
                this.isLoading = true;
                let params = { with: bookingRelations }

                BookingResource.find(this.booking.id, params).then(response => {
                    this.setBookingData(response)
                    this.isLoading = false
                    this.$emit('updated')
                }, e => { handleApiError(e); this.isLoading = false });
            },
            invoiceBooking() {
                this.isLoadingInvoice = true

                if (this.booking.invoice_id) {
                    InvoiceResource.find(this.booking.invoice_id, { with: ['location']}).then(response => {
                        this.$refs['invoiceModal'].open(response.data)
                        this.isLoadingInvoice = false
                    }, e => { handleApiError(e); this.isLoadingInvoice = false })
                    return;
                }

                let tasksComplete = this.bookingTasksComplete(this.booking);
                let confirmMsg = 'Some of the bookings jobs are incomplete, are you sure you want to invoice it?';

                if (tasksComplete || !tasksComplete && confirm(confirmMsg)) {
                    BookingResource.invoice(this.booking.id).then(response => {
                        this.invoiceTemplates = response.data

                        if (response.data.quoteBasis) {
                            this.$refs.invoicingMethod.open();
                        } else {
                            this.invoicingMethodSelected(response.data.costBasis)
                        }
                        
                        this.isLoadingInvoice = false
                    }, e => { handleApiError(e); this.isLoadingInvoice = false })
                } else {
                    this.isLoadingInvoice = false
                }
            },
            invoicingMethodSelected(invoice) {
                this.$refs['invoiceModal'].open(invoice)
                this.$refs.invoicingMethod.close()
            },
            quoteBooking() {
                this.$emit('quote', this.booking)
            },
            presenceUpdated(booking) {
                this.booking.vehicle_presence_status = booking.vehicle_presence_status
                this.booking.vehicle_presence_status_text = booking.vehicle_presence_status_text
                this.booking.vehicle_key_number = booking.vehicle_key_number

                this.$emit('updated')
            },
            taskDestroyed(task) {
                this.tasks = this.tasks.filter(item => { return item !== task });
            },
            // When a task is updated via the TaskModal
            taskUpdated(task) {
                if (this.booking.id) {
                    this.load(this.booking.id);
                    this.$emit('updated');
                } else {
                    this.tasks.push(task);
                }
            },
            // When a task title is updated during booking creation.
            taskChanged(task) {
               /** if (task && 0 === task.title.length && this.tasks.length > 1) {
                    this.tasks = this.tasks.filter(item => item !== task)
                }

                let last = this.tasks[this.tasks.length - 1]

                if (last && last.title && last.title.length > 0) {
                    this.tasks.push(new TaskSchema())
                }**/
            },
            save() {
                return new Promise((resolve, reject) => { 
                    this.isLoading = true;

                    let calendarEntry = Object.assign(this.calendarEntry, {
                        description: 'Booking'
                    })

                    let booking = Object.assign(this.booking, {
                        team_id: this.passedOrLoadedTeam.id,
                        calendar_entry: calendarEntry
                    });

                    BookingResource.storeOrUpdate(booking.id, booking, { with: bookingRelations }).then(response => {
                        let postPromises = [];
                        this.booking = response.data;
                        this.calendarEntry = response.data.calendar_entry;
                        this.calendarEntry.from = new Moment(this.calendarEntry.from)
                        this.calendarEntry.to = new Moment(this.calendarEntry.to)

                        // Add / update the owner if needed.
                        if (booking.instance.owner_id !== booking.contact_id) {
                            let msg = '\'' + booking.contact.primary_display_as + '\' is not '
                                msg += 'the current owner of the vehicle, shall we update '
                                msg += 'the owner of the vehicle to them now?'

                            if (confirm(msg)) {
                                postPromises.push(
                                    VehicleInstanceResource.update(
                                        booking.instance_id, { owner_id: booking.contact_id }
                                    )
                                )
                            }
                        }

                        // Add the tasks.
                        for (let i in this.tasks) {
                            if (!this.tasks[i].id && this.tasks[i].title && this.tasks[i].title.length > 0) {
                                postPromises.push(TaskResource.store(
                                    Object.assign(this.tasks[i], { 
                                        booking_id: response.data.id,
                                        type: TaskTypes.JOB,
                                        instance_id: booking.instance_id
                                    }
                                )))
                            }
                        }

                        // Add the comment.
                        if (this.comment.content && this.comment.content.length > 0) {
                            postPromises.push(CommentResource.store(
                                Object.assign(this.comment, { 
                                    owner: this.modelName + ':' + response.data.id
                                }
                            )))
                        }

                        Promise.all(postPromises).then(() => {
                            this.close();
                            this.$emit('updated')
                            resolve()
                        }, e => { handleApiError(e); this.isLoading = false; reject() })
                    }, (e) => { handleApiError(e); this.isLoading = false; reject() })
                })
            },
            load(id) {
                BookingResource.find(id, { with: bookingRelations }).then(response => {
                    this.setBookingData(response)
                    this.loadedTeam = response.data.team;
                    this.isLoading = false
                }, (e) => { handleApiError(e); this.isLoading = false })
            },
            destroy() {
                if (confirm('Are you sure you want to delete this booking, it\'s related jobs, expenses and time cards?')) {
                    BookingResource.destroy(this.booking.id).then(response => {
                        this.close();
                        this.$emit('destroyed')
                    }, (e) => handleApiError(e))
                }
            },
            reload() {
                if (this.booking.id) {
                    this.load(this.booking.id);
                }
            },
            open(booking = null) {
                if (booking) {
                    booking = Object.assign({}, booking);
                }

                this.reset();

                if (booking && booking.id) {
                    this.isLoading = true

                    this.load(booking.id);
                } else if (booking) {
                    this.booking = booking
                    this.loadedTeam = booking.team

                    if (booking.calendar_entry) {
                        this.calendarEntry = booking.calendar_entry
                    }

                    if (booking.tasks) {
                        this.tasks = booking.tasks
                    }
                }

                this.$refs.bookingModal.open()
            },
            close() {
                this.$refs.bookingModal.close()
            },
            hidden() {
                // Clear the hash, used by the header search to open
                // the booking modal.
                window.history.pushState(
                    [],
                    window.document.title,
                    window.location.href.replace(window.location.hash, '')
                )

                this.$emit('hidden')
            },
            reset() {
                this.tasks = [/*new TaskSchema()*/]
                this.booking = new BookingSchema()
                this.calendarEntry = new CalendarEntrySchema()
                this.comment = new CommentSchema()
                this.isLoading = false
                this.isEditMode = false
            }
        }
    }
</script>